export enum Weight {
  THIN,
  BOOK,
  MEDIUM,
  BOLD,
}